<ng-container *ngIf="ShouldShow$ | async; else loading">
    <ng-container [ngSwitch]="wizard.ProspectType">
        <app-instructor-demographics *ngSwitchCase="'instructor'" (saveDataEvent)="SaveData($event)" [Busy$]="Busy$"></app-instructor-demographics>
    </ng-container>
</ng-container>

<ng-template #loading>
    <p>Loading...</p>
</ng-template>
